import axiosInstance from "../../../../global/helpers/axiosInstance";
import { POST_ABM_FAIL } from "../../../_-_Admin/context/ActionTypes";
import { POST_NOTIFICACION, POST_NOTIFICACION_SUCCESS, PUT_ABM_FAIL, PUT_NOTIFICACION, PUT_NOTIFICACION_SUCCESS, SET_ALERTA_MODAL, SET_ALERTA_MODAL_DELETE } from "../../ActionTypes";

export const wsGetNotificacion = () => (dispatch) => {
    dispatch({ type: POST_NOTIFICACION });
    axiosInstance().then(respuesta => {
        respuesta
            .get("/shared/notificaciones")
            .then((resp) => {
                dispatch({ type: POST_NOTIFICACION_SUCCESS, payload: resp.data });
            })
            .catch((err) => {
                dispatch({ type: POST_ABM_FAIL, payload: err })
            })
    })

};


export const resetNotificacion = () => (dispatch) => {

};

export const wsPutNotiVisto = (idNotificacion, next) => (dispatch) => {
    dispatch({ type: PUT_NOTIFICACION });
    axiosInstance().then(respuesta => {
        respuesta
            .put(`/shared/notificaciones/${idNotificacion}/marcar-leida`)
            .then((resp) => {
                dispatch({ type: PUT_NOTIFICACION_SUCCESS, payload: resp.data });
                if (next) next();
            })
            .catch((err) => {
                dispatch({ type: PUT_ABM_FAIL, payload: err })
            })
    })
}

export const setAlertaModal = (id) => (dispatch) => {
    dispatch({ type: SET_ALERTA_MODAL, payload: id });
}

export const deleteAlertModal = () => (dispatch) => {
    dispatch({ type: SET_ALERTA_MODAL_DELETE });
}